import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import usePagination from 'modules/core/hooks/usePagination'
import i18n from 'modules/core/lib/i18n'

import ValueActions from 'modules/finance/pages/DimensionDetailPage/DimensionDetail/DimensionValuesList/ValueActions'
import type { DimensionValue } from 'modules/finance/pages/DimensionDetailPage/DimensionDetail/useDimensionDetail'

interface Props {
  onDeleteValue: (valueId: number) => void
  onEditValue: (valueId: number) => void
  dimensionValues: DimensionValue[]
}

const DimensionValuesTableBody = ({ dimensionValues, onDeleteValue, onEditValue }: Props) => {
  const { paginatedItems, loadMore, hasMore, page } = usePagination({
    batchSize: 50,
    items: dimensionValues,
  })

  return (
    <Table.BodyWithInfiniteScroll page={page} loadMore={loadMore} hasMore={hasMore} colSpan={10}>
      {paginatedItems.map((dimensionValue) => (
        <Table.Row key={dimensionValue.id}>
          <Table.Cell colSpan={3}>
            <Text.Normal weight="normal" size="200">
              {dimensionValue.name}
            </Text.Normal>
          </Table.Cell>
          <Table.Cell colSpan={2}>
            <Box textAlign="right" paddingX="s24">
              <Text.Normal weight="medium" size="200">
                {dimensionValue.customdimensionmembershipsConnection.totalCount}
              </Text.Normal>
            </Box>
          </Table.Cell>
          <Table.Cell colSpan={3}>
            <Text.Normal weight="medium" size="200">
              {dimensionValue.legalEntity?.legalName ||
                i18n.t('finance.dimension_detail.table.all_legal_entities')}
            </Text.Normal>
          </Table.Cell>
          <Table.Cell colSpan={3}>
            <Text.Normal weight="normal" size="200">
              {dimensionValue.code}
            </Text.Normal>
          </Table.Cell>
          <Table.Cell colSpan={3}>
            <Text.Normal weight="normal" size="200">
              {dimensionValue.description}
            </Text.Normal>
          </Table.Cell>
          <Table.Cell colSpan={1} rowClickable={false}>
            <ValueActions
              valueId={dimensionValue.id}
              onDelete={onDeleteValue}
              onEdit={onEditValue}
            />
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.BodyWithInfiniteScroll>
  )
}

export default observer(DimensionValuesTableBody)
